/*
 * Act as conduits
 *
 * @author Lemuel Raganas <lemuel.raganas@mediacorp.com.sg>
 */
import Vue from "vue";
import MainApp from "@/libs/MainApp";

class DuctVue extends Vue {
  public Vanes = {
    OnPreload: "OnPreload",
    OnPreloadDone: "OnPreloadDone",
    OnError: "OnError",
    OnAppMounted: "OnAppMounted",
    OnDataReady: "OnDataReady",
    OnPostloadDone: "OnPostloadDone",
    OnWorldCupMatchesReady: "OnWorldCupMatchesReady",
  };

  constructor() {
    super();
  }

  open(name: string | string[], handler: Function): DuctVue {
    this.$on(name, handler);
    return this;
  }

  close(name?: string | string[], handler?: Function): DuctVue {
    this.$off(name, handler);
    return this;
  }

  vent(name: string, args?: any, app?: MainApp): DuctVue {
    this.$emit(name, args, app);
    return this;
  }
}

export const Duct = new DuctVue();
